
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexpLyqQfq7V_0wXnPYlumNWjMZ1gwAA7g3K6J6GT68d_wMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/index.vue?macro=true";
import { default as _91slug_93uoFJDDaVA7_45gTjX6i68U_4576kzGnNTxtTKEXGunrt048Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/[slug].vue?macro=true";
import { default as Login7OCqHk0lrvoQ08snS5m_45mgNVblbz1y_45dETBh4k_mxk4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/auth/Login.vue?macro=true";
import { default as Set_45PasswordyXy4dpRTpCZ4QvPIm1p4UJn3OvnXXdF_45nsmPJH66k_UMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/Set-Password.vue?macro=true";
import { default as index6dQ6mLbtrZye0mHS7lpovtpyCZ6RQnpbIsVuKLSriEYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/send/index.vue?macro=true";
import { default as editBctomQjkB0H1JTTYGJCCCX8agHvuuLOBbgmTbszdlVcMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/bulk/edit.vue?macro=true";
import { default as index6kPf93TjgYmToMrY9pI7PEt00oBa_J_gB2DAjIEbB7UMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/otp/index.vue?macro=true";
import { default as indexOSqEormiIsLlmmnrU_452zPW5_JY_Dd6LNSV3uifRNBmMMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/index.vue?macro=true";
import { default as indexifhGpjVW3slkZQXt6uT03lAw2gdiPB_iFrx8NzaGFPQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/links/index.vue?macro=true";
import { default as indexPprBbb9Djv2jwaDs9XpWHW0rsfy5ebzN4S_45vEj1b6ZgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/bulk/index.vue?macro=true";
import { default as indexLd6KVe1tNoagGsJbmj5s8RZW2lr0VQpr49d8Rh56Ze4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/insert/index.vue?macro=true";
import { default as indexKe22Xd1Yte0ipwbIo_45gUUYpwE2oilzf_6CygV7Usz9UMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/cdr/index.vue?macro=true";
import { default as editshe0pnBLRYjiC4GfgN6OyKlOOvlJuJ1Rucy65oJr9OYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/edit.vue?macro=true";
import { default as indextkaJxvKfPpABHbmsvygCkoysYuBNV4HpOALZfLqEsdYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/list/index.vue?macro=true";
import { default as indexH0W_45cY6tS1fwOYcveYe26yY5KkDRkcl29cVCcoSAGSAMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/role/index.vue?macro=true";
import { default as indexOAv89_45Gt_45U9sO7NxGjScVfSe3nRc4GKl1liA8Kqobn4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/numbers/index.vue?macro=true";
import { default as indexr0WDW_gqTPHnggutYM3HIqgBh2PrlTDnTvGKg_4Tyg4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/cost/index.vue?macro=true";
import { default as indexEArtiJPwUOWgKUYA69xV4TWC_LeC8dHennJaegwkQY4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/index.vue?macro=true";
import { default as _91id_93fL2gWySyPBwp4SI08ciu7yyg_45mlV2SQ0aseFDa2RmIYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/[id].vue?macro=true";
import { default as _91id_937X_IeXpMxEJG9xKDyaZltoJM_Bkcy856GRg5o_nM2KwMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/[id].vue?macro=true";
import { default as indexehupZT_afogrB5x682Gx5Numf30zcN2lynXygurafVIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/settings/index.vue?macro=true";
import { default as indexmP37E9AOs5ZO_nqmj14TA9z0C6LRMOixHhKACjuPdAYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/received/index.vue?macro=true";
import { default as index85PU8aeWENySv8orrDi6zaxw7xVwZp_453rkDQdECHieIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/notification/index.vue?macro=true";
import { default as indexK63C1XCfNTT5__45x_45QEYVHS4bSyHUAahhMUnyk0Dbu4kMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/calls/index.vue?macro=true";
import { default as created__3I5AYAMLD8hDfiU1gEpFD1mpgLxA8Zt_euDXCvRsMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/create.vue?macro=true";
import { default as index8PZ_CdS8_kGJE79c60bTmpkhx95Y2tznCO6XJIww0u8Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/ivr/index.vue?macro=true";
import { default as indexKi1n7HkYMo_pCkeihvHO8BOExQDkhxVshhgAHyiEagwMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/support/send/index.vue?macro=true";
import { default as index_jtJJCedX_iZde_PE_45oljlagPGF7q5CXYtZIo16ymHcMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/access/index.vue?macro=true";
import { default as indexDiSzCvQsWTPiQed_45jvqoW3vKv32D4L5S8jErXxgSsloMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/role/index.vue?macro=true";
import { default as indexZtW8ASr1YvhzWci1yA3DwDpm2EJoaY0uAurhOYRCPwwMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/User/index.vue?macro=true";
import { default as indexh_iRZ9jSmCNOTtRNqp6zfN8KRYsrZKK_45BR9LvDWHh_MMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/index.vue?macro=true";
import { default as indexMarh1CzwPXxo0KdbVvCE5I4nGb38cjw6vFz0i_MhMyoMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/index.vue?macro=true";
import { default as indexB21B91pzvFydcRfiVflw9e9O8ApfhO9HU6s7WwDogmYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/submitted/index.vue?macro=true";
import { default as indexdTCJmRet9QO_Gf_45TnbbN0FTKt0GAgevDNkIanmZwdFAMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/rating/index.vue?macro=true";
import { default as indexc9DMtRcwzp9oGnQFoKlxmMiU_vJTNUoXx_45J2jze2wJwMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/message/index.vue?macro=true";
import { default as Forgot_45PasswordXFQYsuE5N8e7zTUjgcA_45rnRRwur98ke7QdCR7BaCgGUMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/auth/Forgot-Password.vue?macro=true";
import { default as _91id_9326HodFqp_45YhSrIsBzaVJMe8n1GcBJndSwXPyfmnDvgoMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/people/[id].vue?macro=true";
import { default as indexH3nTQorMx6w6ND3UBanPDkQ8hVh3e7NaMOqIPCMFDGcMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/tasks/index.vue?macro=true";
import { default as _91id_93ZB1x4jWNqMLZHz_LL29Ui4_bSyQLED4Kpqxzg___pPkMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/[id].vue?macro=true";
import { default as edittouI3hrKuuG64HYTY5ML5Sun_bzavMlUx7VT4g1pK0AMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/edit.vue?macro=true";
import { default as viewWVRwn5MN9BZEH8YVa6a51jnMT_45mER_i_gz1JEh53KvIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/view.vue?macro=true";
import { default as indexzdPYI4Ww2oKkQ7m_qiZiPWZcsZqX4V9zqRdZ8ipY_AQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/waiting/index.vue?macro=true";
import { default as edit8_zM4hO4GR_nTIWGPc6L3ycFmqanEqvILM_EdQ5yxaQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/parametric/edit.vue?macro=true";
import { default as indexreBEstlmm6qLXmHdEa1y25ZmdpKXdSc6ZvMLUJOust0Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/queue/index.vue?macro=true";
import { default as indexqVV8__5_45vTDFBbgur7Cl1y6Xh5F_tuM6ubvWH2uqx08Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/operator/index.vue?macro=true";
import { default as indexN353Uj9XVNqqOBzsgj5NSwWraL3XYCrO9U9Fi1fQOsIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/whatsapp/index.vue?macro=true";
import { default as indexm8_RXSzyjoOyFul9MhzNuamTQ6GX1HQ0PhT7Hczg25kMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Number/index.vue?macro=true";
import { default as _91id_93lx3_F_ByOH8jKHelEw4gJek_IE3Tkl_45IevshbSx628YMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/company/[id].vue?macro=true";
import { default as formULAomDMm_45o_0cTgXU_45FTAJNjlptnmFniXKCqUAUtBJ4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/form.vue?macro=true";
import { default as index8079LP6RPSL0l9y8S8ANatxOBKTTuOZWACipyqkRAscMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/people/index.vue?macro=true";
import { default as indexEyXDJ_nA9X1RZoZvObYYQ8e1c6JCPGoFt_fcoLDgg3kMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/index.vue?macro=true";
import { default as adminHqP5WWK1RyYGraf2420coNFzAJKdISMYizcL44Ks3AwMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/admin.vue?macro=true";
import { default as indexNz48D2r_45svM0cRZm_nTpIwxin3AU8Nheb93Gr3oce14Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/index.vue?macro=true";
import { default as indexQPN_xQtgM_45WvhRRuaZ7H0hU47oQ2DUwxMwRgsLcYTmQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/user/index.vue?macro=true";
import { default as indexPPKSz4IWzHeAZNezX4gWhneH8P5XRiQ1iO4sO_45OQI4kMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/call/index.vue?macro=true";
import { default as indexAAw_45OJh_uolUqNdAGovt2KPxMMwuJh_45xTbXwVjyfEtUMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/answered/index.vue?macro=true";
import { default as indexQlvHvTFCrGkhp6i6PjANLnALJiD6X25qreElioRiw3gMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/fullCdrs/index.vue?macro=true";
import { default as indexCTDAVJSuoDnCQ_m92e6_GlG9ks_45P1ZYV05EdBjiRqFgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/parametric/index.vue?macro=true";
import { default as indexisqv3Crnonpmg89dVZEv_45B_ztGGEX8Bn_45MLizsWNcx4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/phone-book/index.vue?macro=true";
import { default as _91id_93LS67ZQ2BsGl96a8ZYkQHPVPXKEvjkRZhrH8k3drLnQEMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-send/[id].vue?macro=true";
import { default as edit_GctpXI36A_45FJ0SKEv4WUrr0_450w8W5CPdqujR6B91NkMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/send-single/edit.vue?macro=true";
import { default as indexijtgtsjBLZL2HvtoZl4MH1nt3vIICDgVR87I_0Lf_45XsMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/support/tickets/index.vue?macro=true";
import { default as indexha6jjB_4UI1bST3iK_6K1MPj5hbKQb3UYFaPSM8V76UMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/company/index.vue?macro=true";
import { default as archivedAxialx45RH_45QtdGBlNt_07mnUcYM_f5Hv2RGHFzk5pkMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/archived.vue?macro=true";
import { default as indexZCmsU4_45pOYJzEcBSHGWyw_45XiY52ETwdMxpOzcbtdTYYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/index.vue?macro=true";
import { default as archivedT0BxMEi9teXuht9eRd_6o1ssNAu_mTOZfICt1cwtEBgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/archived.vue?macro=true";
import { default as expert7zCCG_45G_45SE4ajZQRs00m3uU4ZD86D1urb2Gs6EcJ6toMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/expert.vue?macro=true";
import { default as indexFp_45WerhcUliAINEhN4P1Hxx96QV_45yl7IqZhrt8N8qmYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/users/index.vue?macro=true";
import { default as indexgAa2BlXWxMFwrV_45nfxxJKAGRu_sjSs9KE1bTZnsoIEYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-send/index.vue?macro=true";
import { default as indexdGVKHZP3Dj67LbFVi7Kve0UjnQDZTzX15VnudrOW6mgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/send-single/index.vue?macro=true";
import { default as indexxxS60FKSpX8ZQzxtxVKU3eufCv1NXRDGbsNyOH2EfqYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/forward/index.vue?macro=true";
import { default as indexGPqb87MubYc8LRo6NFxYh19LdIbA28YzpRsVooc3vJIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/department/index.vue?macro=true";
import { default as indexlVByU2Upi90MWN0FvGC4KNQjJPXnpj4j9aWFccDHfd4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Settings/index.vue?macro=true";
import { default as _91id_93PNM88fQYw2bFe9uZdUP5BgiilQ_45BQZOxKiDkeHKg0IgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/inventory/[id].vue?macro=true";
import { default as indexerlNI8golb779nQdDtgl4WSIsGk6ZH7lb6IaGiKpFNIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/products/index.vue?macro=true";
import { default as indexzti65NCPsBLxb_m6jESu1kKW9k1ZCdK_4MhBLishVXQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/timeLine/index.vue?macro=true";
import { default as indexlw2JeJx_45JjAreHLLNH70P8MsaMfTsZoU5hqM7Vq2WdsMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/whatsapp/index.vue?macro=true";
import { default as indexHLdmHBQw0nTEUTgyTIycWi5qgOLDEKpyNj9w0yykiz8Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/report/index.vue?macro=true";
import { default as indexOe3IFc_45hsmvT8qZsyHArMLraXBNbXuNmabh3b7FRmF4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/scatteirng/index.vue?macro=true";
import { default as editVwYY7aVIltve4UYgkrSM_PgvEFbJsyvmzKlV4MGJcu4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/corresponding/edit.vue?macro=true";
import { default as _91id_93hoTm0Ob26qPyySoJlfhQ2E6ekclP4vFO_45nyj1C0m_45XUMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/voiceMail/[id].vue?macro=true";
import { default as index6OXM4d7CHfLkvdHSIjUSKF29T_45vhI0QvTkf_nzVIGzQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/index.vue?macro=true";
import { default as indexpAEUBaYfSadk1iFEcxQLgEfY7PRbxroy45yyFwG_45NLEMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/dashboard/index.vue?macro=true";
import { default as index_32copyIwxyVH3XtiM_ltqwQxdwyvHuf_gUwFXewI49Fb6XFl4Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/User/index copy.vue?macro=true";
import { default as indexL3HRvFWOXFNfVQzmQKFXB_TPYZO2oTYZtkhdnenK_KkMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/inventory/index.vue?macro=true";
import { default as setting_45reSMsW3fsobUPzU3ubDLhh7WggMVAsggKGuF7_45vz74Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/setting.vue?macro=true";
import { default as archived65QbkxCLNzDZtbgGu5BpkbefUOarYCtO2SaF5LYsp24Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/archived.vue?macro=true";
import { default as indexm0pVfW1z3YusQZqeweJlbzNYWuc5VulHNMh_455c5jHrIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/missedCalls/index.vue?macro=true";
import { default as index13cXUPhDPDzrEX5G1c98GrskDw4OQg2MX3vHIr_456VpEMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/corresponding/index.vue?macro=true";
import { default as indexAwI_45Z89eZ3285CffS0Y_8VZb4WOoYtpBGY7ULg4b0NAMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/blackList/index.vue?macro=true";
import { default as indexCa3TVKdjZyKJAkpGVvn_45dxfrzG1qnIkGR8JIra16BO0Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/recording/index.vue?macro=true";
import { default as index8CsLA2GRQ06FHnBRRe22THf5CE9RSl2SEReSBvUc_yAMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/voiceMail/index.vue?macro=true";
import { default as index_8OdHBEh0EAxw1Im4jc_qqSUvPIEzcAe2FIxdHb_kb0Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Department/index.vue?macro=true";
import { default as indexaLnZjk1tU_45_45_4_454y2gGxvYADXNeMIzUfmnGe9d28Sl8Meta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/automation/workflow/index.vue?macro=true";
import { default as archiveds4gqAtRlRUdYwRz08spLaTa9WjtliagEuY27rw5GUHsMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/archived.vue?macro=true";
import { default as indexNH_rfuICgQGtrR2iTqtO4YgQtSMetCLJ_YJ2uCwbe6kMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/hangupReason/index.vue?macro=true";
import { default as indexjVsQ75B1XqZ48h_FF_u92aGyRARwpIBafBE2XthL4kYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-receive/index.vue?macro=true";
import { default as indexu7xqe8gbkLx_B2LMxN3UoZgbCGDh_45fCW4eFkv90_45aMEMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/wallboard/index.vue?macro=true";
import { default as indexlj2rIQO1wQyE16UDMR98Bs4Ku3LnptFZ_T_45Mwra_45bLYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/destination/index.vue?macro=true";
import { default as index3LuM45rnc5McftP8boK1jgVCN730kwQnJt76VnajEDIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/reports/ticketsReport/index.vue?macro=true";
import { default as _91id_93yg2irpBMlbT_TuLUkSMgKfqkEhJQVfe9oR1GLG2DvhIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/phone-book/groups/[id].vue?macro=true";
import { default as indexLMYQtXZpiWg8ttzbmEHlUp15ni7CYZhl5zSrnhHNeFkMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/conversations/index.vue?macro=true";
import { default as indexTYLY7j0z72jTqY_a5ey_45allhRdaUJjA6ZELi7rIn5XMMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/timeCondition/index.vue?macro=true";
import { default as indexGbywUi7x_45lJ_0KdYBmRWWjgnNOHnPfWccceLDdkO1QAMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/whatsappMessages/index.vue?macro=true";
import { default as index3Ay_452OkOpu6PegRXWlbvGSexzpIBfG0O6ozIqDDFWvIMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/videoConference/report/index.vue?macro=true";
import { default as index_32copya4cNfyFEH7yqzE3JZDlic_45Io2TJahLscSHrgI6h0aLYMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/index copy.vue?macro=true";
import { default as index67mDwCIYnUOSrxJ9aOcooKormCG1XHHy7LDskBvm91wMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/operatorActivity/index.vue?macro=true";
import { default as reactiveData08Xbo4r3N1vOPv1ChhIrgyKhqR7AXJu_GJI1uzxG_45fgMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/reactiveData.ts?macro=true";
import { default as indexiZXdR_45Ycukxesf8DGmWm5IxpvVhNF26CJwoElLlEgJQMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/videoConference/createLink/index.vue?macro=true";
import { default as component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71XoMeta } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71Xo } from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93uoFJDDaVA7_45gTjX6i68U_4576kzGnNTxtTKEXGunrt048Meta || {},
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/[slug].vue")
  },
  {
    name: "auth-Login",
    path: "/auth/Login",
    meta: Login7OCqHk0lrvoQ08snS5m_45mgNVblbz1y_45dETBh4k_mxk4Meta || {},
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/auth/Login.vue")
  },
  {
    name: "Set-Password",
    path: "/Set-Password",
    meta: Set_45PasswordyXy4dpRTpCZ4QvPIm1p4UJn3OvnXXdF_45nsmPJH66k_UMeta || {},
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/Set-Password.vue")
  },
  {
    name: "fax-send",
    path: "/fax/send",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/send/index.vue")
  },
  {
    name: "send-bulk-edit",
    path: "/send/bulk/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/bulk/edit.vue")
  },
  {
    name: "send-otp",
    path: "/send/otp",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/otp/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/index.vue")
  },
  {
    name: "crm-links",
    path: "/crm/links",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/links/index.vue")
  },
  {
    name: "send-bulk",
    path: "/send/bulk",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/bulk/index.vue")
  },
  {
    name: "fax-insert",
    path: "/fax/insert",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/insert/index.vue")
  },
  {
    name: "report-cdr",
    path: "/report/cdr",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/cdr/index.vue")
  },
  {
    name: "send-groups-edit",
    path: "/send/groups/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/edit.vue")
  },
  {
    name: "users-list",
    path: "/users/list",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/list/index.vue")
  },
  {
    name: "users-role",
    path: "/users/role",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/role/index.vue")
  },
  {
    name: "crm-numbers",
    path: "/crm/numbers",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/numbers/index.vue")
  },
  {
    name: "report-cost",
    path: "/report/cost",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/cost/index.vue")
  },
  {
    name: "send-groups",
    path: "/send/groups",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/index.vue")
  },
  {
    name: "contacts-deal-id",
    path: "/contacts/deal/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/[id].vue")
  },
  {
    name: "contacts-lead-id",
    path: "/contacts/lead/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/[id].vue")
  },
  {
    name: "crm-settings",
    path: "/crm/settings",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/crm/settings/index.vue")
  },
  {
    name: "fax-received",
    path: "/fax/received",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/received/index.vue")
  },
  {
    name: "notification",
    path: "/notification",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/notification/index.vue")
  },
  {
    name: "report-calls",
    path: "/report/calls",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/calls/index.vue")
  },
  {
    name: "send-groups-create",
    path: "/send/groups/create",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/groups/create.vue")
  },
  {
    name: "settings-ivr",
    path: "/settings/ivr",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/ivr/index.vue")
  },
  {
    name: "support-send",
    path: "/support/send",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/support/send/index.vue")
  },
  {
    name: "users-access",
    path: "/users/access",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/access/index.vue")
  },
  {
    name: "webchat-role",
    path: "/webchat/role",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/role/index.vue")
  },
  {
    name: "webchat-User",
    path: "/webchat/User",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/User/index.vue")
  },
  {
    name: "contacts-deal",
    path: "/contacts/deal",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/index.vue")
  },
  {
    name: "contacts-lead",
    path: "/contacts/lead",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/index.vue")
  },
  {
    name: "fax-submitted",
    path: "/fax/submitted",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/fax/submitted/index.vue")
  },
  {
    name: "report-rating",
    path: "/report/rating",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/rating/index.vue")
  },
  {
    name: "users-message",
    path: "/users/message",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/message/index.vue")
  },
  {
    name: "auth-Forgot-Password",
    path: "/auth/Forgot-Password",
    meta: Forgot_45PasswordXFQYsuE5N8e7zTUjgcA_45rnRRwur98ke7QdCR7BaCgGUMeta || {},
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/auth/Forgot-Password.vue")
  },
  {
    name: "contacts-people-id",
    path: "/contacts/people/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/people/[id].vue")
  },
  {
    name: "contacts-tasks",
    path: "/contacts/tasks",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/tasks/index.vue")
  },
  {
    name: "contacts-ticket-id",
    path: "/contacts/ticket/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/[id].vue")
  },
  {
    name: "evaluation-save-edit",
    path: "/evaluation/save/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/edit.vue")
  },
  {
    name: "evaluation-save-view",
    path: "/evaluation/save/view",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/view.vue")
  },
  {
    name: "report-waiting",
    path: "/report/waiting",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/waiting/index.vue")
  },
  {
    name: "send-parametric-edit",
    path: "/send/parametric/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/parametric/edit.vue")
  },
  {
    name: "settings-queue",
    path: "/settings/queue",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/queue/index.vue")
  },
  {
    name: "users-operator",
    path: "/users/operator",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/operator/index.vue")
  },
  {
    name: "users-whatsapp",
    path: "/users/whatsapp",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/whatsapp/index.vue")
  },
  {
    name: "webchat-Number",
    path: "/webchat/Number",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Number/index.vue")
  },
  {
    name: "contacts-company-id",
    path: "/contacts/company/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/company/[id].vue")
  },
  {
    name: "contacts-invoice-form",
    path: "/contacts/invoice/form",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/form.vue")
  },
  {
    name: "contacts-people",
    path: "/contacts/people",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/people/index.vue")
  },
  {
    name: "contacts-ticket",
    path: "/contacts/ticket",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/index.vue")
  },
  {
    name: "evaluation-save-admin",
    path: "/evaluation/save/admin",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/admin.vue")
  },
  {
    name: "evaluation-save",
    path: "/evaluation/save",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/index.vue")
  },
  {
    name: "evaluation-user",
    path: "/evaluation/user",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/user/index.vue")
  },
  {
    name: "monitoring-call",
    path: "/monitoring/call",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/call/index.vue")
  },
  {
    name: "report-answered",
    path: "/report/answered",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/answered/index.vue")
  },
  {
    name: "report-fullCdrs",
    path: "/report/fullCdrs",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/fullCdrs/index.vue")
  },
  {
    name: "send-parametric",
    path: "/send/parametric",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/parametric/index.vue")
  },
  {
    name: "send-phone-book",
    path: "/send/phone-book",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/phone-book/index.vue")
  },
  {
    name: "send-report-send-id",
    path: "/send/report-send/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-send/[id].vue")
  },
  {
    name: "send-send-single-edit",
    path: "/send/send-single/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/send-single/edit.vue")
  },
  {
    name: "support-tickets",
    path: "/support/tickets",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/support/tickets/index.vue")
  },
  {
    name: "contacts-company",
    path: "/contacts/company",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/company/index.vue")
  },
  {
    name: "contacts-deal-archived",
    path: "/contacts/deal/archived",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/deal/archived.vue")
  },
  {
    name: "contacts-invoice",
    path: "/contacts/invoice",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/index.vue")
  },
  {
    name: "contacts-lead-archived",
    path: "/contacts/lead/archived",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/lead/archived.vue")
  },
  {
    name: "evaluation-save-expert",
    path: "/evaluation/save/expert",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/save/expert.vue")
  },
  {
    name: "monitoring-users",
    path: "/monitoring/users",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/users/index.vue")
  },
  {
    name: "send-report-send",
    path: "/send/report-send",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-send/index.vue")
  },
  {
    name: "send-send-single",
    path: "/send/send-single",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/send-single/index.vue")
  },
  {
    name: "settings-forward",
    path: "/settings/forward",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/forward/index.vue")
  },
  {
    name: "users-department",
    path: "/users/department",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/department/index.vue")
  },
  {
    name: "webchat-Settings",
    path: "/webchat/Settings",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Settings/index.vue")
  },
  {
    name: "contacts-inventory-id",
    path: "/contacts/inventory/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/inventory/[id].vue")
  },
  {
    name: "contacts-products",
    path: "/contacts/products",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/products/index.vue")
  },
  {
    name: "contacts-timeLine",
    path: "/contacts/timeLine",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/timeLine/index.vue")
  },
  {
    name: "contacts-whatsapp",
    path: "/contacts/whatsapp",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/whatsapp/index.vue")
  },
  {
    name: "evaluation-report",
    path: "/evaluation/report",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/evaluation/report/index.vue")
  },
  {
    name: "report-scatteirng",
    path: "/report/scatteirng",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/scatteirng/index.vue")
  },
  {
    name: "send-corresponding-edit",
    path: "/send/corresponding/edit",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/corresponding/edit.vue")
  },
  {
    name: "settings-voiceMail-id",
    path: "/settings/voiceMail/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/voiceMail/[id].vue")
  },
  {
    name: "webchat-Customize",
    path: "/webchat/Customize",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/index.vue")
  },
  {
    name: "webchat-dashboard",
    path: "/webchat/dashboard",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/dashboard/index.vue")
  },
  {
    name: "webchat-User-index copy",
    path: "/webchat/User/index%20copy",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/User/index copy.vue")
  },
  {
    name: "contacts-inventory",
    path: "/contacts/inventory",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/inventory/index.vue")
  },
  {
    name: "contacts-invoice-setting",
    path: "/contacts/invoice/setting",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/setting.vue")
  },
  {
    name: "contacts-ticket-archived",
    path: "/contacts/ticket/archived",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/ticket/archived.vue")
  },
  {
    name: "report-missedCalls",
    path: "/report/missedCalls",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/missedCalls/index.vue")
  },
  {
    name: "send-corresponding",
    path: "/send/corresponding",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/corresponding/index.vue")
  },
  {
    name: "settings-blackList",
    path: "/settings/blackList",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/blackList/index.vue")
  },
  {
    name: "settings-recording",
    path: "/settings/recording",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/recording/index.vue")
  },
  {
    name: "settings-voiceMail",
    path: "/settings/voiceMail",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/voiceMail/index.vue")
  },
  {
    name: "webchat-Department",
    path: "/webchat/Department",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Department/index.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/workflow",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/automation/workflow/index.vue")
  },
  {
    name: "contacts-invoice-archived",
    path: "/contacts/invoice/archived",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/contacts/invoice/archived.vue")
  },
  {
    name: "report-hangupReason",
    path: "/report/hangupReason",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/hangupReason/index.vue")
  },
  {
    name: "send-report-receive",
    path: "/send/report-receive",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/report-receive/index.vue")
  },
  {
    name: "monitoring-wallboard",
    path: "/monitoring/wallboard",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/monitoring/wallboard/index.vue")
  },
  {
    name: "settings-destination",
    path: "/settings/destination",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/destination/index.vue")
  },
  {
    name: "reports-ticketsReport",
    path: "/reports/ticketsReport",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/reports/ticketsReport/index.vue")
  },
  {
    name: "send-phone-book-groups-id",
    path: "/send/phone-book/groups/:id()",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/send/phone-book/groups/[id].vue")
  },
  {
    name: "webchat-conversations",
    path: "/webchat/conversations",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/conversations/index.vue")
  },
  {
    name: "settings-timeCondition",
    path: "/settings/timeCondition",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/settings/timeCondition/index.vue")
  },
  {
    name: "users-whatsappMessages",
    path: "/users/whatsappMessages",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/users/whatsappMessages/index.vue")
  },
  {
    name: "videoConference-report",
    path: "/videoConference/report",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/videoConference/report/index.vue")
  },
  {
    name: "webchat-Customize-index copy",
    path: "/webchat/Customize/index%20copy",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/index copy.vue")
  },
  {
    name: "report-operatorActivity",
    path: "/report/operatorActivity",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/report/operatorActivity/index.vue")
  },
  {
    name: "webchat-Customize-reactiveData",
    path: "/webchat/Customize/reactiveData",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/webchat/Customize/reactiveData.ts")
  },
  {
    name: "videoConference-createLink",
    path: "/videoConference/createLink",
    component: () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/pages/videoConference/createLink/index.vue")
  },
  {
    name: component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71XoMeta?.name,
    path: "/monitoring/dashboard",
    component: component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71Xo
  },
  {
    name: component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71XoMeta?.name,
    path: "/login",
    component: component_45stub_UcHnd7eaLhboTIlhrk9Um0Ku8X4vwx2pNaC_iz71Xo
  }
]